export default "__VITE_ASSET__Bj7V0H4f__"